import React, { useMemo, useState } from "react";
import { Col, Container, Collapse, Card, Accordion, Row } from "react-bootstrap";
import "./CollapsePanel.scss";


export const CollapsePanel = ({ field, renderItem, watch }) => {
  const hidden = field?.hide ? field.hide({ watch }) : false;
  const label = useMemo(
    () =>
      typeof field.label === "function" ? field.label({ watch }) : field?.label,
    [field.label, watch]
  );


  if (hidden) {
    return null;
  }

  return (
    <div className="he3-collapse-panel" style={{ padding: '0 16px', ...field?.style }}>
      <Accordion defaultActiveKey={field?.defaultOpen ? "0" : undefined}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>{label}</Accordion.Header>
          <Accordion.Body>
            {field.items.map(item => renderItem(item))}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  )
};
